/**
 * index
 */
export * from './src/index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-react-base/index.js
// module id = 193
// module chunks = 0